// src/store/uiSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  featurePanelOpen: boolean;
  examSchedulePanelOpen: boolean;
}

const initialState: UIState = {
  featurePanelOpen: true,
  examSchedulePanelOpen: true,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setFeaturePanelOpen(state, action: PayloadAction<boolean>) {
      state.featurePanelOpen = action.payload;
    },
    setExamSchedulePanelOpen(state, action: PayloadAction<boolean>) {
      state.examSchedulePanelOpen = action.payload;
    },
  },
});

export const { setFeaturePanelOpen, setExamSchedulePanelOpen } = uiSlice.actions;
export default uiSlice.reducer;

